import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import covidComponent from './components/covidComponent.vue';
import clientFormComponent from './components/clientFormComponent.vue';
Vue.use(VueAxios,axios);
// Vue.prototype.$http = axios


new Vue({
    el: '#app',
    components: {
        covidComponent,
        clientFormComponent
      }
}).$mount('#app');



